class StickyMenu {
  constructor() {
    this.header = document.querySelector("header");
    this.events();
  }

  events() {
    window.addEventListener("scroll", () => this.changeHeader());
  }

  changeHeader() {
    this.scrollPos = window.scrollY;
    if (this.scrollPos > 200) {
      this.header.classList.add("header__sticky");
    } else {
      this.header.classList.remove("header__sticky");
    }
  }
}

export default StickyMenu;
